<script setup>
import {defineProps, defineEmits} from "vue";

defineProps({
    show: Boolean,
    loading: Boolean,
    disabled: Boolean,
    error: Boolean,
    block: Boolean,
})

const emit = defineEmits(["press"]);

function press() {
    emit('press');
}
</script>

<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'teal'"
        :loading="loading"
        :disabled="disabled"
        :block="block"
        :text="$t('common.validate')"
        :icon="error ? 'mdi-alert' : 'mdi-content-save-cog'"
        @press="press"
    />
</template>

<style scoped>

</style>